import { useState as B, useEffect as b, useLayoutEffect as G, useRef as E, useCallback as H, forwardRef as g } from "react";
import { h as w, i as R, j as o, R as J, B as f, G as M, l as P, m as S, q as K, s as z, p as W, U as X, r as Y, n as k } from "./UnstyledButton-ujNMaBde.js";
import { createPortal as q } from "react-dom";
const ee = {
  app: 100,
  modal: 200,
  popover: 300,
  overlay: 400,
  max: 9999
};
function ye(e) {
  return ee[e];
}
function he(e = "mantine-") {
  return `${e}${Math.random().toString(36).slice(2, 11)}`;
}
function te(e, t) {
  try {
    return e.addEventListener("change", t), () => e.removeEventListener("change", t);
  } catch {
    return e.addListener(t), () => e.removeListener(t);
  }
}
function se(e, t) {
  return typeof window < "u" && "matchMedia" in window ? window.matchMedia(e).matches : !1;
}
function ae(e, t, { getInitialValueInEffect: s } = {
  getInitialValueInEffect: !0
}) {
  const [a, n] = B(
    s ? t : se(e)
  );
  return b(() => {
    try {
      const i = window.matchMedia(e);
      return n(i.matches), te(i, (d) => n(d.matches));
    } catch {
      return;
    }
  }, [e]), a || !1;
}
const ne = typeof document < "u" ? G : b;
function be(e, t) {
  const s = E(!1);
  b(
    () => () => {
      s.current = !1;
    },
    []
  ), b(() => {
    if (s.current)
      return e();
    s.current = !0;
  }, t);
}
function C(e, t) {
  if (typeof e == "function")
    return e(t);
  typeof e == "object" && e !== null && "current" in e && (e.current = t);
}
function oe(...e) {
  const t = /* @__PURE__ */ new Map();
  return (s) => {
    if (e.forEach((a) => {
      const n = C(a, s);
      n && t.set(a, n);
    }), t.size > 0)
      return () => {
        e.forEach((a) => {
          const n = t.get(a);
          n && typeof n == "function" ? n() : C(a, null);
        }), t.clear();
      };
  };
}
function ge(...e) {
  return H(oe(...e), e);
}
function xe(e, t) {
  return ae("(prefers-reduced-motion: reduce)", e, t);
}
function j(e) {
  const t = document.createElement("div");
  return t.setAttribute("data-portal", "true"), typeof e.className == "string" && t.classList.add(...e.className.split(" ").filter(Boolean)), typeof e.style == "object" && Object.assign(t.style, e.style), typeof e.id == "string" && t.setAttribute("id", e.id), t;
}
function re({ target: e, reuseTargetNode: t, ...s }) {
  if (e)
    return typeof e == "string" ? document.querySelector(e) || j(s) : e;
  if (t) {
    const a = document.querySelector("[data-mantine-shared-portal-node]");
    if (a)
      return a;
    const n = j(s);
    return n.setAttribute("data-mantine-shared-portal-node", "true"), document.body.appendChild(n), n;
  }
  return j(s);
}
const ce = {
  reuseTargetNode: !0
}, I = w((e, t) => {
  const { children: s, target: a, reuseTargetNode: n, ...i } = R("Portal", ce, e), [d, l] = B(!1), r = E(null);
  return ne(() => (l(!0), r.current = re({ target: a, reuseTargetNode: n, ...i }), C(t, r.current), !a && !n && r.current && document.body.appendChild(r.current), () => {
    !a && !n && r.current && document.body.removeChild(r.current);
  }), [a]), !d || !r.current ? null : q(/* @__PURE__ */ o.jsx(o.Fragment, { children: s }), r.current);
});
I.displayName = "@mantine/core/Portal";
const ie = w(
  ({ withinPortal: e = !0, children: t, ...s }, a) => J() === "test" || !e ? /* @__PURE__ */ o.jsx(o.Fragment, { children: t }) : /* @__PURE__ */ o.jsx(I, { ref: a, ...s, children: t })
);
ie.displayName = "@mantine/core/OptionalPortal";
var c = { root: "m_5ae2e3c", barsLoader: "m_7a2bd4cd", bar: "m_870bb79", "bars-loader-animation": "m_5d2b3b9d", dotsLoader: "m_4e3f22d7", dot: "m_870c4af", "loader-dots-animation": "m_aac34a1", ovalLoader: "m_b34414df", "oval-loader-animation": "m_f8e89c4b" };
const O = g(({ className: e, ...t }, s) => /* @__PURE__ */ o.jsxs(f, { component: "span", className: M(c.barsLoader, e), ...t, ref: s, children: [
  /* @__PURE__ */ o.jsx("span", { className: c.bar }),
  /* @__PURE__ */ o.jsx("span", { className: c.bar }),
  /* @__PURE__ */ o.jsx("span", { className: c.bar })
] }));
O.displayName = "@mantine/core/Bars";
const $ = g(({ className: e, ...t }, s) => /* @__PURE__ */ o.jsxs(f, { component: "span", className: M(c.dotsLoader, e), ...t, ref: s, children: [
  /* @__PURE__ */ o.jsx("span", { className: c.dot }),
  /* @__PURE__ */ o.jsx("span", { className: c.dot }),
  /* @__PURE__ */ o.jsx("span", { className: c.dot })
] }));
$.displayName = "@mantine/core/Dots";
const D = g(({ className: e, ...t }, s) => /* @__PURE__ */ o.jsx(f, { component: "span", className: M(c.ovalLoader, e), ...t, ref: s }));
D.displayName = "@mantine/core/Oval";
const T = {
  bars: O,
  oval: D,
  dots: $
}, de = {
  loaders: T,
  type: "oval"
}, le = S((e, { size: t, color: s }) => ({
  root: {
    "--loader-size": z(t, "loader-size"),
    "--loader-color": s ? K(s, e) : void 0
  }
})), _ = w((e, t) => {
  const s = R("Loader", de, e), {
    size: a,
    color: n,
    type: i,
    vars: d,
    className: l,
    style: r,
    classNames: x,
    styles: L,
    unstyled: p,
    loaders: v,
    variant: u,
    children: m,
    attributes: N,
    ...y
  } = s, h = P({
    name: "Loader",
    props: s,
    classes: c,
    className: l,
    style: r,
    classNames: x,
    styles: L,
    unstyled: p,
    attributes: N,
    vars: d,
    varsResolver: le
  });
  return m ? /* @__PURE__ */ o.jsx(f, { ...h("root"), ref: t, ...y, children: m }) : /* @__PURE__ */ o.jsx(
    f,
    {
      ...h("root"),
      ref: t,
      component: v[i],
      variant: u,
      size: a,
      ...y
    }
  );
});
_.defaultLoaders = T;
_.classes = c;
_.displayName = "@mantine/core/Loader";
const V = g(
  ({ size: e = "var(--cb-icon-size, 70%)", style: t, ...s }, a) => /* @__PURE__ */ o.jsx(
    "svg",
    {
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: { ...t, width: e, height: e },
      ref: a,
      ...s,
      children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      )
    }
  )
);
V.displayName = "@mantine/core/CloseIcon";
var A = { root: "m_86a44da5", "root--subtle": "m_220c80f2" };
const ue = {
  variant: "subtle"
}, me = S((e, { size: t, radius: s, iconSize: a }) => ({
  root: {
    "--cb-size": z(t, "cb-size"),
    "--cb-radius": s === void 0 ? void 0 : k(s),
    "--cb-icon-size": Y(a)
  }
})), F = W((e, t) => {
  const s = R("CloseButton", ue, e), {
    iconSize: a,
    children: n,
    vars: i,
    radius: d,
    className: l,
    classNames: r,
    style: x,
    styles: L,
    unstyled: p,
    "data-disabled": v,
    disabled: u,
    variant: m,
    icon: N,
    mod: y,
    attributes: h,
    __staticSelector: U,
    ...Q
  } = s, Z = P({
    name: U || "CloseButton",
    props: s,
    className: l,
    style: x,
    classes: A,
    classNames: r,
    styles: L,
    unstyled: p,
    attributes: h,
    vars: i,
    varsResolver: me
  });
  return /* @__PURE__ */ o.jsxs(
    X,
    {
      ref: t,
      ...Q,
      unstyled: p,
      variant: m,
      disabled: u,
      mod: [{ disabled: u || v }, y],
      ...Z("root", { variant: m, active: !u && !v }),
      children: [
        N || /* @__PURE__ */ o.jsx(V, {}),
        n
      ]
    }
  );
});
F.classes = A;
F.displayName = "@mantine/core/CloseButton";
export {
  F as C,
  _ as L,
  ie as O,
  ge as a,
  xe as b,
  be as c,
  ae as d,
  V as e,
  C as f,
  ye as g,
  oe as m,
  he as r,
  ne as u
};
